module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_kobe-c96ca68973ec22ffafc62abfb6668c04.jpg";